/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown>, menu: NonNullable<unknown> }} Tournament_Wiz_Tip_Paid_Gate_BInputs */



/**
* | output |
* | --- |
* | "Each player has a payment status you set when they arrive. {action}, in the console's {menu} menu, marks everyone paid at once." |
*
* @param {Tournament_Wiz_Tip_Paid_Gate_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_paid_gate_b = /** @type {((inputs: Tournament_Wiz_Tip_Paid_Gate_BInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Paid_Gate_BInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Chaque joueur a un statut de paiement que vous réglez à son arrivée. ${i?.action}, dans le menu ${i?.menu} de la console, marque tout le monde comme payé d'un coup.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Cada jugador tiene un estado de pago que usted marca al llegar. ${i?.action}, en el menú ${i?.menu} de la consola, marca a todos como pagados de una vez.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Cada jogador tem um status de pagamento que você define na chegada. ${i?.action}, no menu ${i?.menu} do console, marca todos como pagos de uma vez.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ogni giocatore ha uno stato di pagamento che imposti al suo arrivo. ${i?.action}, nel menu ${i?.menu} della console, segna tutti come pagati in un colpo.`)
	return /** @type {LocalizedString} */ (`Each player has a payment status you set when they arrive. ${i?.action}, in the console's ${i?.menu} menu, marks everyone paid at once.`)
});